function Eye(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M240 360c88.8 0 166.4-48.3 207.9-120A240 240 0 0 0 32 240 240 240 0 0 0 240 360Z"></path></svg>
    )
}

export default Eye